// Translation file for authentication pages

export const auth = {
  login: {
    title: "Login",
    subtitle: "Log in to your account and continue your work",
    heroTitle: "Sign In",
    heroSubtitle: "Continue your journey with us",
    email: "Email address",
    password: "Password",
    loginButton: "Sign In",
    loginButtonLoading: "Signing in...",
    googleLogin: "Sign in with Google account",
    googleLoginAlt: "Sign in with Google",
    or: "or",
    forgotPassword: "Forgot password?",
    noAccount: "Don't have an account yet?",
    register: "Register",
    backToLanding: "← Back to homepage",
    noBespirePage: "Don't have your own Bespire page yet?",
    startNow: "Start now",
    errorTitle: "Invalid login credentials",
    errorDescription: "Please check your email and password, then try again.",
    googleErrorTitle: "Error occurred during Google sign in",
    googleErrorDescription: "Please try again later."
  },
  register: {
    title: "Create your account",
    subtitle: "Start your journey with us today",
    username: "Username",
    fullName: "Full name",
    email: "Email address",
    phone: "Phone number",
    registerButton: "Free registration",
    googleRegister: "Sign in with Google account",
    or: "or",
    termsText: "By registering you accept the",
    termsLink: "Terms and Conditions",
    and: "and the",
    privacyLink: "Privacy Policy",
    hasAccount: "Already have an account?",
    login: "Sign In"
  },
  languages: {
    hungarian: "Magyar",
    english: "English",
    german: "Deutsch",
    french: "Français",
    italian: "Italiano",
    spanish: "Español",
    dutch: "Nederlands",
    polish: "Polski"
  }
};